import z from "zod";

/* ---------------- pip/cases/state/CaseState.java --------------- */
export const caseStateValueSchema = z.enum([
  "NEW",
  "IN_PROGRESS",
  "ENDED",
  "REOPENED",
]);

export type CaseStateValue = z.infer<typeof caseStateValueSchema>;
